import i18n from '@/plugins/i18n';
const processesMSGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.buffer-pool-size-per-db-in-bytes'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_bufferpool_size_per_database_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.size'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.transaction-log-growth'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_log_transaction_growth',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.no-of-expansions'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.deadlocks'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_stats_deadlocks_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.deadlocks'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.user-errors'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_user_errors',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.errors-minute'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.buffer-pool-size-in-bytes'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_bufferpool_size_in_bytes',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.size-in-bytes'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.system-buffer-pool-hit-percentage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a3ff99', '#b4ccb7'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_system_buffer_pool_hit_percent',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.hit-percentage'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
    {
      width: '49%',
      header: {
        title: i18n.global.t('dbm.totalOpenFiles'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#F7507F', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_total_open_files',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
      showmetricRate: true,
    },
  ],
});

export default processesMSGraphs;
